import { create } from 'zustand';
import apiClient from '../services/axiosInterceptor';

export interface FeeStructureItem {
  id: number;
  fee_type_id: number;
  fee_name: string;
  class_id: number;
  session: string;
  month_year: string;
  amount: number;
  created_at: string;
  updated_at: string;
}

interface FeeStructureStore {
  className: string | null;
  session: string | null;
  feeStructures: Record<string, FeeStructureItem[]>;
  hasData: boolean;
  loading: boolean;
  error: string | null;

  fetchFeeStructure: (classId: number, session: string) => Promise<void>;
  reset: () => void;
}

export const useFeeStructureStore = create<FeeStructureStore>((set) => ({
  className: null,
  session: null,
  feeStructures: {}, // ✅ Correct: assign empty object to feeStructures
  hasData: false,
  loading: false,
  error: null,

  fetchFeeStructure: async (classId, session) => {
    set({ loading: true, error: null });

    try {
      const response = await apiClient.get(
        `/fee-structures-by-class?class_id=${classId}&session=${encodeURIComponent(session)}`
      );

      const { status, message, class_name, fee_structures } = response.data;

      console.log('fees structure response', response.data);

      if (status !== 'success') {
        throw new Error(message || 'Failed to fetch fee structure');
      }

      const normalizedStructures: Record<string, FeeStructureItem[]> =
        fee_structures && typeof fee_structures === 'object' && !Array.isArray(fee_structures)
          ? fee_structures
          : {};

      const hasData = Object.keys(normalizedStructures).length > 0;

      set({
        className: class_name || null,
        session,
        feeStructures: normalizedStructures,
        hasData,
        loading: false,
      });
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        'Failed to load fee structure';

      set({
        className: null,
        session: null,
        feeStructures: {}, // ✅ Fixed
        hasData: false,
        loading: false,
        error: errorMessage,
      });
    }
  },

  reset: () => {
    set({
      className: null,
      session: null,
      feeStructures: {}, // ✅ Fixed
      hasData: false,
      loading: false,
      error: null,
    });
  },
}));